/* eslint-disable quotes, quote-props, comma-dangle  */
import type { TranslationProps } from './types';

export const translations = {
  "cancel_button_label": [
    {
      "type": 0,
      "value": "취소"
    }
  ],
  "warning_body_list_item_one": [
    {
      "type": 0,
      "value": "고객 데이터 액세스에 대한 비즈니스 정당성을 확보했습니다."
    }
  ],
  "warning_body_list_item_two": [
    {
      "type": 0,
      "value": "귀하의 다운로드 활동은 보안 규정 준수 목적으로 기록 및 추적됩니다."
    }
  ],
  "warning_footer": [
    {
      "type": 0,
      "value": "계속 진행하시겠어요?"
    }
  ],
  "warning_header": [
    {
      "type": 0,
      "value": "다운로드하면 다음 사항을 인정하는 것으로 간주됩니다."
    }
  ]
};

function TranslationProviderComponent({ children }: TranslationProps) {
  return children(translations);
}

export default Object.assign(TranslationProviderComponent, { translations });
